import { useCallback } from 'react'

export default () => useCallback((event) => {
  if (event.key === ' ') {
    event.preventDefault()
  }
}, [])
